import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';

@i18n
class Complain extends Component {
  render() {
    return (
      <Grid>
        <Row>
          <Col lg={12}>
            <h1>{this.i18n('Muligheder for at klage')}</h1>
            <p>
              Hvis du ønsker at klage over en tjenesteydelse købt hos
              Boligninja.dk, bedes du kontakte vores kundeservice på
              info@boligninja.dk, som vil behandle og forsøge at løse din
              klagesag hurtigst muligt.
              <br />
              <br />
              Du har som forbruger også mulighed for klage over en vare eller
              tjenesteydelse købt hos Boligninja.dk til:
              <br />
              <br />
              Konkurrence- og Forbrugerstyrelsens Center for Klageløsning, Carl
              Jacobsens Vej 35, 2500 Valby
              <br />
              via http://www.forbrug.dk
              <br />
              <br />
              eller
              <br />
              <br />
              EU-Kommissionens har oprettet en online klageportal på
              http://ec.europa.eu/odr, hvor du ligeledes kan indgive din klage.
              EU-Kommissionens klageportal er især relevant, hvis du har bopæl i
              et andet EU-land.
              <br />
              Ved indgivelse af en klage, skal du oplyse vores e-mail adresse;
              info@boligninja.dk
            </p>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Complain;
